import { CALL_INIT, MEDIA_CHANGE, CALL_END, CALL_STATUS_CHANGE, CALL_CONNECTED } from '../constants/ActionTypes';

function getInitCallAction({ flowId, phone, mediaType, token, apiUrl }) {
  return {
    type: CALL_INIT,
    payload: {
      flowId,
      phone,
      token,
      apiUrl,
      type: mediaType
    }
  }
}

function getConnectCallAction({ callId }) {
  return {
    type: CALL_CONNECTED,
    payload: {
      callId
    }
  }
}

function getChangeMediaAction({ mediaType, status }) {
  return {
    type: MEDIA_CHANGE,
    payload: {
      type: mediaType,
      status: status
    }
  }
}

function getChangeStatusAction({ status }) {
  return {
    type: CALL_STATUS_CHANGE,
    payload: {
      status
    }
  }
}


function getEndAction() {
  return {
    type: CALL_END
  }
}


export default {
  getInitCallAction,
  getChangeMediaAction,
  getChangeStatusAction,
  getEndAction,
  getConnectCallAction
}